import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../supabase';
import SchoolSidebar from './SchoolSidebar';
import './SchoolDashboard.css';

function VehicleManagement(){
  const navigate = useNavigate();
  const [schoolData, setSchoolData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [vehicles, setVehicles] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ bus_number:'', registration_no:'', capacity:50, available_seats:50, driver_name:'', driver_phone:'', assistant_name:'', assistant_phone:'', rules_policies:'' });

  useEffect(()=>{
    const sd = localStorage.getItem('schoolData');
    if(!sd){ navigate('/schoollogin'); return; }
    setSchoolData(JSON.parse(sd));
    setLoading(false);
  },[navigate]);

  useEffect(()=>{ if(schoolData?.id) fetchVehicles(); },[schoolData?.id]);

  const fetchVehicles = async ()=>{
    const { data } = await supabase.from('transport_vehicles').select('*').eq('school_id', schoolData.id).order('created_at', {ascending:false});
    setVehicles(data || []);
  };

  const resetForm = ()=> { setEditing(null); setForm({ bus_number:'', registration_no:'', capacity:50, available_seats:50, driver_name:'', driver_phone:'', assistant_name:'', assistant_phone:'', rules_policies:'' }); };

  const saveVehicle = async ()=>{
    if(!form.bus_number) return alert('Bus number required');
    if(!form.capacity) return alert('Capacity required');
    if(editing){
      const { error } = await supabase.from('transport_vehicles').update({ ...form, updated_at: new Date().toISOString() }).eq('id', editing.id);
      if(error) return alert(error.message);
    } else {
      const { error } = await supabase.from('transport_vehicles').insert({ school_id: schoolData.id, ...form });
      if(error) return alert(error.message);
    }
    await fetchVehicles();
    resetForm();
  };

  const editVehicle = (v)=> { setEditing(v); setForm({ bus_number:v.bus_number, registration_no:v.registration_no || '', capacity:v.capacity || 0, available_seats: v.available_seats ?? v.capacity, driver_name:v.driver_name||'', driver_phone:v.driver_phone||'', assistant_name:v.assistant_name||'', assistant_phone:v.assistant_phone||'', rules_policies:v.rules_policies||'' }); };
  const deleteVehicle = async (id)=> { if(!window.confirm('Delete vehicle?')) return; await supabase.from('transport_vehicles').delete().eq('id', id); await fetchVehicles(); if(editing?.id===id) resetForm(); };

  const handleLogout = ()=> navigate('/schoollogin');
  if(loading) return <div className="loading-container"><div className="loading-spinner"></div><p>Loading...</p></div>;

  return (
    <div className="school-dashboard">
      <SchoolSidebar schoolData={schoolData} onLogout={handleLogout} />
      <div className="main-content">
        <div className="content-header"><h1>🚍 Vehicle Management</h1><p>Add/Edit/View/Remove bus details, seats, drivers, and rules</p></div>

        <div className="classes-content">
          <div className="classes-header"><h1>{editing? 'Edit Vehicle' : 'Add Vehicle'}</h1></div>
          <div style={{padding:'1rem'}}>
            <div className="form-row">
              <div className="form-group"><label>Bus Name/Number *</label><input value={form.bus_number} onChange={(e)=> setForm({...form, bus_number:e.target.value})} /></div>
              <div className="form-group"><label>Registration No</label><input value={form.registration_no} onChange={(e)=> setForm({...form, registration_no:e.target.value})} /></div>
              <div className="form-group"><label>Capacity *</label><input type="number" value={form.capacity} onChange={(e)=> setForm({...form, capacity:parseInt(e.target.value||'0',10), available_seats: Math.min(form.available_seats, parseInt(e.target.value||'0',10))})} /></div>
              <div className="form-group"><label>Available Seats</label><input type="number" value={form.available_seats} onChange={(e)=> setForm({...form, available_seats: parseInt(e.target.value||'0',10)})} /></div>
            </div>

            <div className="form-row">
              <div className="form-group"><label>Driver Name</label><input value={form.driver_name} onChange={(e)=> setForm({...form, driver_name:e.target.value})} /></div>
              <div className="form-group"><label>Driver Phone</label><input value={form.driver_phone} onChange={(e)=> setForm({...form, driver_phone:e.target.value})} /></div>
              <div className="form-group"><label>Assistant Name</label><input value={form.assistant_name} onChange={(e)=> setForm({...form, assistant_name:e.target.value})} /></div>
              <div className="form-group"><label>Assistant Phone</label><input value={form.assistant_phone} onChange={(e)=> setForm({...form, assistant_phone:e.target.value})} /></div>
            </div>

            <div className="form-group"><label>Bus Rules & Policies</label><textarea rows="4" value={form.rules_policies} onChange={(e)=> setForm({...form, rules_policies:e.target.value})}></textarea></div>

            <div className="form-actions"><button className="btn-primary" onClick={saveVehicle}>{editing? 'Save Changes':'Add Vehicle'}</button>{editing && <button className="btn-secondary" onClick={resetForm}>Cancel</button>}</div>
          </div>
        </div>

        <div className="classes-content" style={{marginTop:'1rem'}}>
          <div className="classes-header"><h1>All Vehicles</h1></div>
          <div className="classes-table-container">
            <table className="classes-table"><thead><tr><th>Bus</th><th>Reg No</th><th>Capacity</th><th>Available</th><th>Driver</th><th>Assistant</th><th>Actions</th></tr></thead><tbody>
              {vehicles.map(v=> (
                <tr key={v.id}>
                  <td>{v.bus_number}</td>
                  <td>{v.registration_no || '-'}</td>
                  <td>{v.capacity}</td>
                  <td>{v.available_seats ?? '-'}</td>
                  <td>{v.driver_name || '-'}</td>
                  <td>{v.assistant_name || '-'}</td>
                  <td>
                    <button className="edit-btn" onClick={()=> editVehicle(v)}>Edit</button>
                    <button className="delete-btn" onClick={()=> deleteVehicle(v.id)}>Delete</button>
                  </td>
                </tr>
              ))}
            </tbody></table>
          </div>
        </div>

      </div>
    </div>
  );
}

export default VehicleManagement;


